// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-segment {
  width: 30px;
  height: 30px;
  margin-top: 32px;
  border-color: #960C0C;
  color: white !important;
  background-color: #960C0C;
}
.delete-segment:hover {
  border-color: #dc3545 !important;
  background-color: #dc3545 !important;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/edozvola/cases/case-segment/case-segments.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;AACF;AACE;EACE,gCAAA;EACA,oCAAA;AACJ","sourcesContent":[".delete-segment {\n  width: 30px;\n  height: 30px;\n  margin-top: 32px;\n  border-color: #960C0C;\n  color: white !important;\n  background-color: #960C0C;\n\n  &:hover {\n    border-color: #dc3545 !important;\n    background-color: #dc3545 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
